import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { config } from "../../../config";

const imageUrl = config.imageUrl;

const UpdateMembership = ({
  formData,
  handleChange,
  handleQuillChange,
  handleBenefitChange,
  handleSubmit,
  addBenefit,
  removeBenefit,
  setPhoto,
  loading,
  error,
  onCancel
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link', 'image'],
      ['clean']
    ],
  };

  return (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
      <div className="p-6 max-w-4xl mx-auto bg-white shadow rounded-lg">
        <h2 className="text-2xl font-bold mb-4">Update Membership</h2>

        {loading && (
          <div className="mb-4 p-3 bg-blue-100 text-blue-800 rounded">
            Updating membership...
          </div>
        )}

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-800 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-6 p-4 border rounded-lg">
            <h3 className="text-lg font-semibold mb-3">Membership Information</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Membership Type*</label>
                <input
                  type="text"
                  name="membership_type"
                  value={formData.membership_type}
                  onChange={handleChange}
                  className="border w-full p-2 rounded focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Duration*</label>
                <input
                  type="text"
                  name="membership_duration"
                  value={formData.membership_duration}
                  onChange={handleChange}
                  className="border w-full p-2 rounded focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Selling Price (৳)*</label>
                <input
                  type="number"
                  name="selling_price"
                  value={formData.selling_price}
                  onChange={handleChange}
                  className="border w-full p-2 rounded focus:ring-2 focus:ring-blue-500"
                  min="0"
                  step="0.01"
                  required
                />
              </div>
              
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Discount Price (৳)*</label>
                <input
                  type="number"
                  name="discount_price"
                  value={formData.discount_price}
                  onChange={handleChange}
                  className="border w-full p-2 rounded focus:ring-2 focus:ring-blue-500"
                  min="0"
                  step="0.01"
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Membership Image</label>
              {formData.image && (
                <div className="mb-2">
                  <img
                    src={
                      typeof formData.image === 'string' 
                        ? `${imageUrl}/${formData.image}`
                        : URL.createObjectURL(formData.image)
                    }
                    alt="Current membership"
                    className="h-24 w-24 object-cover rounded border"
                    onError={(e) => {
                      e.target.src = '/default-membership.png';
                      e.target.onerror = null;
                    }}
                  />
                </div>
              )}
              <input
                type="file"
                onChange={(e) => setPhoto(e.target.files[0])}
                className="border w-full p-2 rounded focus:ring-2 focus:ring-blue-500"
                accept="image/*"
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Description*</label>
              <ReactQuill
                value={formData.membership_description || ""}
                onChange={handleQuillChange}
                modules={modules}
                className="border rounded focus:ring-2 focus:ring-blue-500"
                theme="snow"
              />
            </div>
          </div>
          
          <div className="mb-6 p-4 border rounded-lg">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold">Membership Benefits</h3>
              <button 
                type="button" 
                onClick={addBenefit}
                className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
              >
                Add Benefit
              </button>
            </div>
            
            {formData.benefits.length > 0 ? (
              formData.benefits.map((benefit, index) => (
                <div key={index} className="mb-4 p-3 border rounded bg-gray-50">
                  <div className="flex justify-between items-center mb-2">
                    <h4 className="font-medium">Benefit #{index + 1}</h4>
                    <button
                      type="button"
                      onClick={() => removeBenefit(index)}
                      className="text-red-600 hover:text-red-800 text-sm"
                    >
                      Remove
                    </button>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                    <div>
                      <label className="block text-gray-700 text-sm mb-1">Benefit Name*</label>
                      <input
                        type="text"
                        name="benefit_name"
                        value={benefit.benefit_name}
                        onChange={(e) => handleBenefitChange(index, e)}
                        className="border w-full p-2 rounded text-sm focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-gray-700 text-sm mb-1">Icon (React class: MdVerified, FaCrown, BsBullseye)</label>
                      <input
                        type="text"
                        name="icon"
                        value={benefit.icon}
                        onChange={(e) => handleBenefitChange(index, e)}
                        className="border w-full p-2 rounded text-sm focus:ring-2 focus:ring-blue-500"
                        placeholder="e.g. fa-check"
                      />
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="block text-gray-700 text-sm mb-1">Description*</label>
                    <textarea
                      name="description"
                      value={benefit.description}
                      onChange={(e) => handleBenefitChange(index, e)}
                      className="border w-full p-2 rounded text-sm focus:ring-2 focus:ring-blue-500"
                      rows="2"
                      required
                    />
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700 text-sm mb-1">Sort Order</label>
                      <input
                        type="number"
                        name="sort_order"
                        value={benefit.sort_order}
                        onChange={(e) => handleBenefitChange(index, e)}
                        className="border w-full p-2 rounded text-sm focus:ring-2 focus:ring-blue-500"
                        min="0"
                      />
                    </div>
                    
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        name="is_active"
                        id={`is_active_${index}`}
                        checked={benefit.is_active}
                        onChange={(e) => handleBenefitChange(index, e)}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <label htmlFor={`is_active_${index}`} className="text-gray-700 text-sm">
                        Active Benefit
                      </label>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-center py-4">No benefits added yet</p>
            )}
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 disabled:bg-blue-400"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Membership"}
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default UpdateMembership;